//grab the item of userID
export const useGetUserID = () => {
  return window.localStorage.getItem("userID")
}
